import { Tabs } from "antd";
import { parseAsStringEnum, useQueryState } from "nuqs";
import React from "react";

import { AgentSkillKind } from "@fitness-app/data-models/entities/AgentSkill";

import { AdvisorModelCard } from "./AdvisorModelCard";
import { AdvisorResourceList } from "./AdvisorResourceList";

// TRE-1613 — advisor settings. Mirrors the support agent's settings (SupportSettings):
// prompt skills and a company/program knowledge base, both stored in agent_skill,
// plus the model configuration (app_config, type client_advisor).

const settingsTabKeys = [AgentSkillKind.Skill, AgentSkillKind.Knowledge] as const;

export const AdvisorSettingsTab = (): React.ReactElement => {
  const [activeTab, setActiveTab] = useQueryState(
    "settingsTab",
    parseAsStringEnum<AgentSkillKind>([...settingsTabKeys]).withDefault(AgentSkillKind.Skill),
  );

  return (
    <>
      <AdvisorModelCard />
      <Tabs
        activeKey={activeTab}
        onChange={(key) => void setActiveTab(key as AgentSkillKind)}
        destroyInactiveTabPane
        items={[
          {
            key: AgentSkillKind.Skill,
            label: "Skille",
            children: <AdvisorResourceList kind={AgentSkillKind.Skill} />,
          },
          {
            key: AgentSkillKind.Knowledge,
            label: "Baza wiedzy",
            children: <AdvisorResourceList kind={AgentSkillKind.Knowledge} />,
          },
        ]}
      />
    </>
  );
};
